// extracted by mini-css-extract-plugin
module.exports = {"VisionSlider":"OurVision_VisionSlider__CY--2","TitleFont":"OurVision_TitleFont__1hWxj","Img":"OurVision_Img__1yz9S","ImgBg":"OurVision_ImgBg__PkeSX"};